import { ColDef } from 'ag-grid-community';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { JSON_PRE_GERADO_TIPO } from '@gestor-web/@core/api/ords/model';
import { Store } from '@ngrx/store';
import { CompetenciaPipe } from '@gestor-web/app/shared/pipes/competencia.pipe';
import { NotificationService } from '@gestor-web/app/shared/services';
import { AnalisesService } from '../../analises.service';
import { BaseConsultaComponent } from './base-consulta.component';
import { GridService } from '@gestor-web/app/shared/services/grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GeralService } from '@gestor-web/app/shared/services/geral.service';
const COLUMNS: ColDef[] = [
  // Pivot (area=column)
  /*
  {
    headerName: 'Operadora',
    field: 'DS_OPERADORA',
    pivotIndex: 0,
  },
  */
  {
    headerName: 'Faixa etária',
    field: 'TP_FAIXA_ETARIA',
    pivotIndex: 0,
  },

  // Row Groups (area=row)
  {
    headerName: 'Tabela TUSS',
    field: 'CD_TABELA_TUSS',
    rowGroupIndex: 0,
    sort: 'asc',
  },
  {
    headerName: 'Vínculo internação',
    field: 'DS_VINCULO_INTERNACAO',
    rowGroupIndex: 1,
    sort: 'asc',
  },
  {
    headerName: 'Qtde item CNS',
    field: 'DS_QTDE_ITEM_CNS',
    rowGroupIndex: 2,
    sort: 'asc',
  },

  // Aggs (area=data)
  {
    headerName: 'Qtde resultado',
    field: 'QT_RESULTADO',
    type: 'int',
    aggFunc: 'sum',
  },
  {
    headerName: 'Qtde ignorado',
    field: 'QT_IGNORADO',
    type: 'int',
    aggFunc: 'sum',
  },

  // Hidden (area=filter)
  {
    headerName: 'Cód. proced. item',
    field: 'CD_PROCED_ITEM',
    hide: true,
  },
  {
    headerName: 'Nome proced. item',
    field: 'NM_PROCED_ITEM',
    hide: true,
  },
  {
    headerName: '021-Tipo de guia',
    field: 'DS_TIPO_GUIA',
    hide: true,
  },
  {
    headerName: '039-Tipo de internação',
    field: 'DS_TIPO_INTERNACAO',
    hide: true,
  },
  {
    headerName: '045-Tipo de atendimento',
    field: 'DS_TIPO_ATENDIMENTO',
    hide: true,
  },
  {
    headerName: '034-Tipo de consulta',
    field: 'DS_TIPO_CONSULTA',
    hide: true,
  },
];

@Component({
    selector: 'bl-indicadores-consulta-diabeticos',
    templateUrl: './base-consulta.component.html',
    styleUrls: ['./base-consulta.component.scss'],
    providers: [DecimalPipe],
    standalone: false
})
export class CuidadoDiabeticoComponent extends BaseConsultaComponent {
  constructor(
    service: AnalisesService,
    notificationService: NotificationService,
    gridService: GridService,
    geralService: GeralService,
    competeciaPipe: CompetenciaPipe,
    decimalPipe: DecimalPipe,
    datePipe: DatePipe,
    store: Store,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      service,
      notificationService,
      gridService,
      geralService,
      competeciaPipe,
      decimalPipe,
      datePipe,
      store,
      router,
      route,
    );
  }

  getColumns(): ColDef[] {
    return COLUMNS;
  }

  getPageTooltip(): string {
    return 'CUBOS_ANALISE.METRICAS.CUIDADO_DIABETICO';
  }

  getConsultaTipo(): JSON_PRE_GERADO_TIPO {
    return 'IND_CUBO_HEMOGLOBINA_GLICADA';
  }

  getExportTitle(): string {
    return 'Cubos de análise - 1.6 - Cuidado ao diabético (Numerador)';
  }

  getExportFilePrefix(): string {
    return 'Cubos-Cuidado-Diabetico';
  }
}
